<template>
	<div class="popup_high_right delete-discount side-popup"
	     :class="['level-'+level]">

		<a @click="$emit('close')" v-if="!level" class="close_popup_btn">
			<inline-svg :src="require('@/assets/img/popup_close.svg')"/>
		</a>

		<div class="popup-container scroll">
			<h3 class="title" >
				<back-btn v-if="level" class="back-btn" @click="$emit('close')" />
				<span class="layout-row">
				Delete discount
<!--				<span class="order-number">-->
<!--					 "{{ discount ? discount.name : '&#45;&#45;' }}"-->
<!--				</span>-->
				</span>
			</h3>

			<div class="layout-row flex-center">
				<label class="label">Name:</label>
				<span class="value" >
					{{discount.name || ''}}
				</span>
				<div class="flex"></div>
			</div>
			<div class="layout-row flex-center">
				<label class="label">Discount:</label>
				<span class="value" >
					{{brief || ''}}
				</span>
				<div class="flex"></div>
			</div>
			<div class="layout-row flex-center">
				<label class="label">Start date:</label>
				<span class="value" >
					{{date || ''}}
				</span>
				<div class="flex"></div>
			</div>

			<div style="height: 50px" ></div>
			<div class="layout-column">
				<div class="alert_box orange">
					<inline-svg class="icon" :src="require('@/assets/img/alert_icon_yellow.svg')" />
					<div class="desc">
						This can't be undone. <br>
					</div>
				</div>
			</div>
		</div>

		<div class="popup-actions layout-row">
			<v-button label="Delete discount" red border @click="deleteDiscount" :loading="loading" />
			<v-button label="Keep discount" border @click="$emit('close')" />
		</div>

	</div>
</template>

<script>
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";
import Loading from "@/components/Loading";
import BackBtn from "@/components/base/back-btn";
import InputField from "@/components/base/input-field";
import numbers from "@/helpers/numbers";
import API from '@/api'
import {mapGetters} from "vuex";
import {getSymbol} from "@/helpers/currencies";
const moment = require('moment-timezone');

export default {
	name: "delete-discount",
	components: {
		InputField,  BackBtn, Loading, VButton, Popup},
	mixins:[API],
	props:{
		discount:{
			type: Object,
		},
		level:{
			type: Number,
			default: 0,
		},
	},
	data(){
		return {
			loading: false,
		}
	},
	computed:{
		...mapGetters(['getDiscountsStore']),
		brief() {
			if (this.discount.type===1) // percentage
				return `${this.discount.value}% off all products`
			else
				return `${this.currency}${this.discount.value} off all products`
		},
		date() {
			let d = this.discount.created_at;

			let dd = moment(d);
			if (dd.isSame(moment(), 'day'))
				return 'Today, '+dd.format("HH:mm")
			if (dd.isSame(moment(), 'year'))
				return dd.format("DD MMM, HH:mm")
			return dd.format("DD MMM YYYY, HH:mm")
		},
		currency() {
			let c = this.$store.state.userInfo.currency_code;
			if (!c) return '$';
			return getSymbol(c);
		}
	},
	methods:{
		async deleteDiscount(){
			try {
				this.loading = true;

				let discount = await this.api.discounts.delete(this.discount.id);
				if (discount.error) this.$error(discount.error);
				else {
					let index = this.getDiscountsStore.findIndex(x=>x.id===this.discount.id);
					if (index>=0) {
						this.getDiscountsStore.splice(index, 1);
					}

					this.$emit('done');
					this.$info('','Discount code deleted')
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.loading = false;
			}
		},

	}
}
</script>

<style lang="scss" scoped>
.delete-discount {
		padding: 0;
	.value {
		margin-left: 10px;
		display: flex;
		font-size: 14px;
		font-weight: 500;
		color: $darker-grey;
		//height: auto;
		//padding: 10px 0 0 10px;
	}

	.basic-details {
		margin: 15px 0;
	}
	.order-number {
		color: $black;
		margin-left: 5px;
	}
		&.archived {
			.title {
				color: $dark-grey;
			}
		}
		&.canceled {
			.title {
				text-decoration: line-through;
			}
		}
		.status-tags {
			display: flex;
			flex-direction: row;
			margin-right: 25px;
		}
		.status-tag {
			border-radius: 5px;
			background: $light-silver;
			padding: 3px 10px;
			display: flex;
			flex-direction: row;
			align-items: center;
			.value {
				margin: 0 0 0 5px;
			}
			svg {
				//color: #18d7ae;
				height: 18px;
				&.refund {
					color: $black;
				}
			}
			margin-right: 3px;
		}
		&.level-1 {
			max-width: 580px;
			box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
		}
		&.level-2 {
			max-width: 560px;
			box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
		}
		.title {
			display: flex;
			flex-direction: column;
			align-items: start;
			position: relative;
			.back-btn {
				position: absolute;
				top: -30px;
			}
		}

		.popup_high_right {
			padding: 0;
		}
		.title {
			font-size: 22px;
			line-height: 150%;
			font-weight: 600;
			letter-spacing: 0.02em;
			color: #252A32;
			margin-bottom: 5px;
			background: white;
			min-height: 40px;
		}
		.popup-container {
			display: flex;
			flex-direction: column;
			flex: 1;
			padding: 35px 30px 20px;
		}

	.order-status-row {
		margin-top: 10px;
		margin-bottom: 10px;
		display: flex;
		flex-direction: row;
		font-size: 13px;
		align-items: center;
		color: #26252e;
		.label {
			font-weight: bold;
			margin-right: 10px;
		}
		.value {
			display: flex;
			flex-direction: row;
			margin-right: 30px;
			margin-left: 5px;
		}
	}
}
</style>
